export const authKeys = {
  all: ['auth'] as const,

  currentUser: () => [...authKeys.all, 'current-user'] as const,
  sessionProbe: () => [...authKeys.all, 'session-probe'] as const,
  accessAdmins: () => [...authKeys.all, 'access-admins'] as const,
  myApplications: () => [...authKeys.all, 'my-applications'] as const,
};
